export const FAQ_BILLING_TYPE = 'BILLING_TYPE';
export const FAQ_INVOICE_ADDR_MANAGEMENT = 'INV_ADDR_MANAGEMENT';
export const FAQ_INVOICE_COMPLIANCE = 'INV_COMPLIANCE';
export const FAQ_BATCH_BILLING = 'BATCH_BILLING';
export const FAQ_PAYMENT_TYPE = 'PAYMENT_TYPE';
export const FAQ_LEASING = 'LEASING';
export const FAQ_ELECTRONIC_INVOICE = 'ELECTRONIC_INV';
export const FAQ_CHARGEBACK = 'CHARGEBACK';
export const FAQ_INVOICE_REPORTS = 'INV_REPORTS';
export const FAQ_SPEND_DASHBOARD = 'SPEND_DASHBOARD';
export const FAQ_ORDER_MANAGEMENT_TYPES = 'ORDER_MANAGEMENT_TYPES';
export const FAQ_BP_ACTIVATION_LETTER = 'BP_ACTIVATION_LETTER';
export const FAQ_CUSTOMER_B2B_FORM = 'CUSTOMER_B2B_FORM';
export const FAQ_B2B_CAPABILITIES = 'B2B_CAPABILITIES';
export const FAQ_B2B_BROKER_SSO = 'B2B_BROKER_SSO';
export const FAQ_ARIBA_AGREEMENT = 'ARIBA_AGREEMENT';
export const FAQ_BP_AGREEMENT = 'BP_AGREEMENT';
export const FAQ_BP_BANK_INFO:string = 'BP_BANK_INFO';
export const FAQ_LEASING_WEBSHOPS_SETTINGS = 'LEASING_WEBSHOPS_SETTINGS';
